import { render, staticRenderFns } from "./shipment-mode.vue?vue&type=template&id=3e9ddbbd"
import script from "./shipment-mode.vue?vue&type=script&lang=js"
export * from "./shipment-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports